import React from 'react'

import HtmlContent from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/HtmlContent'
import SectionContainer from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/components/SectionContainer'
import { useRecommendedPartner } from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartner'

const WorkingWithYou: React.FC = () => {
  const workingWithYou = useRecommendedPartner().workingWithYou

  return (
    <SectionContainer>
      <HtmlContent html={workingWithYou || ''} />
    </SectionContainer>
  )
}

export default WorkingWithYou
